import './assets/scss/index.scss';
import 'react-toastify/dist/ReactToastify.css';

import App from './pages/root/App';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import { IconContext } from 'react-icons';
import LanguageProvider from './provider/LanguageProvider';
import { Provider } from 'react-redux';
import React from 'react';
import { ToastContainer } from 'react-toastify';

import configureStore from './store/configureStore';
import { createRoot } from 'react-dom/client';

// Create Redux store with middlewares
const container = document.querySelector('#root')!;
const root = createRoot(container);

const store = configureStore();

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <IconContext.Provider value={{ className: 'react-icons' }}>
          <LanguageProvider>
            <App />
            <ToastContainer autoClose={5000} />
          </LanguageProvider>
        </IconContext.Provider>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);
